import { InjectionToken } from "@angular/core";

export const LOG_LEVEL = new InjectionToken<LogLevel>("ErpProLogLevel");

export const enum LogLevel
{
    ERROR = "ERROR",
    WARNING = "WARNING",
    INFORMATION = "INFORMATION",
    DEBUG = "DEBUG",
    TRACE = "TRACE",
}
